module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details"
  }, [_c('table', {
    staticClass: "members-table"
  }, [_c('tr', [_vm._m(0), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("角色")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.project')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("部门")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("账号状态")]), _vm._v(" "), (_vm.canDo('edit_members') && !_vm.tbcMode) ? _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("操作")]) : _vm._e()]), _vm._v(" "), (_vm.loading) ? _c('tr', [_vm._m(1)]) : _vm._l((_vm.members), function(member) {
    return _c('tr', {
      key: member.id
    }, [_vm._o(_c('td', {
      staticClass: "profile"
    }, [_c('div', {
      staticClass: "img avatar",
      style: ({
        backgroundImage: 'url(' + member.user.profile_picture + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "nickname"
    }, [_vm._v(_vm._s(member.user.nickname))]), _vm._v(" "), _c('div', {
      staticClass: "email"
    }, [_vm._v(_vm._s(member.user.email))])]), 0, member.id), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t(("roles." + (member.role)))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(member.projects_count))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(member.department))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t(("memberState." + (member.state)))))]), _vm._v(" "), (_vm.canDo('edit_members') && !_vm.tbcMode) ? _c('td', [_c('el-button', {
      attrs: {
        "type": "text",
        "theme": "info"
      },
      on: {
        "click": function($event) {
          _vm.editMember(member)
        }
      }
    }, [_vm._v("编辑")]), _vm._v(" "), (member.role !== 'owner') ? _c('el-button', {
      attrs: {
        "type": "text",
        "theme": "danger"
      },
      on: {
        "click": function($event) {
          _vm.removeMember(member.id)
        }
      }
    }, [_vm._v("删除")]) : _vm._e()], 1) : _vm._e()])
  })], 2), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "small": "",
      "layout": "prev, pager, next",
      "total": _vm.totalItems,
      "page-count": _vm.totalPages,
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "current-change": _vm.fetch
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('span', [_vm._v("所有成员")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "loading-cell",
    attrs: {
      "colspan": "10"
    }
  }, [_c('div', {
    staticClass: "spinner-wrapper"
  }, [_c('i', {
    staticClass: "ppj-icon-spinner"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d8232bb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/members/details/index.vue
// module id = 893
// module chunks = 3